import { __decorate, __metadata } from 'tslib';
import { Injectable, NgModule } from '@angular/core';
import { ApiService, UiBsOauthModule } from '@wlp/ui-bs-oauth';
import { of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

const SPE_N_PRE_PIX_PROXY = '/spe-n-pre-pix';
let SpeNPrePixProxy = class SpeNPrePixProxy {
    constructor(api) {
        this.api = api;
    }
    /**
     * Cria um novo usuario para o pre cadastro do pix
     * @param form
     */
    createPrePix(form) {
        const uri = `${SPE_N_PRE_PIX_PROXY}/v1/pre-account-pix`;
        let prepix;
        return this.api.post(uri, form).pipe(map((result) => {
            if (result !== null && result !== undefined) {
                prepix = {
                    message: 'Usuário salvo com sucesso!',
                    user: result,
                };
                return prepix;
            }
            throw 'Houve um erro ao salvar os dados!';
        }), catchError((err) => {
            prepix = {
                message: err,
                user: null,
            };
            return of(prepix);
        }));
    }
    /**
     * Atualiza usuario do pre cadastro do pix
     * @param id
     * @param uuidWL
     * @param form
     */
    updatePrePix(id, uuidWL, form) {
        const uri = `${SPE_N_PRE_PIX_PROXY}/v1/pre-account-pix/${uuidWL}/${id}`;
        let prepix;
        return this.api.put(uri, form).pipe(map((result) => {
            if (result !== null && result !== undefined) {
                prepix = {
                    message: 'Usuário atualizado com sucesso!',
                    user: result,
                };
                return prepix;
            }
            throw 'Houve um erro ao salvar os dados!';
        }), catchError((err) => {
            prepix = {
                message: err,
                user: null,
            };
            return of(prepix);
        }));
    }
};
SpeNPrePixProxy = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiService])
], SpeNPrePixProxy);

const SPE_VIEW_N_PRE_PIX = '/spe-view-n-pre-pix';
let SpeViewNPrePixProxy = class SpeViewNPrePixProxy {
    constructor(api) {
        this.api = api;
    }
    /**
     * Retorna o usuario cadastrado no pre pix
     * @param uuidWL
     * @param uuidUser
     */
    getPrePix(uuidWL, uuidUser) {
        const uri = `${SPE_VIEW_N_PRE_PIX}/v1/pre-account-pix/${uuidWL}/${uuidUser}`;
        let prepix;
        return this.api.get(uri)
            .pipe(map((result) => {
            if (result !== null && result !== undefined) {
                prepix = {
                    message: 'Usuário encontrado!',
                    user: result
                };
                return prepix;
            }
            throw 'Houve um erro ao buscar este usuário!';
        }), catchError(err => {
            prepix = {
                message: err,
                user: null
            };
            return of(prepix);
        }));
    }
    /**
     * Retorna todos os usuarios cadastrados no pre pix (do white label)
     * @param uuidWL
     */
    getPrePixAll(uuidWL) {
        const uri = `${SPE_VIEW_N_PRE_PIX}/v1/pre-account-pix/${uuidWL}`;
        let prepix;
        return this.api.get(uri)
            .pipe(map((result) => {
            if (result !== null && result !== undefined) {
                return result;
            }
            throw 'Houve um erro ao buscar este usuário!';
        }), catchError(err => {
            prepix = {
                message: err,
                user: null
            };
            return of(prepix);
        }));
    }
    /**
     * Retorna um conjunto de keys que ainda não foram informadas pelo usuario
     * @param uuidWL
     * @param uuidUser
     */
    checkUserKeys(uuidWL, uuidUser) {
        const uri = `${SPE_VIEW_N_PRE_PIX}/v1/pre-account-pix/keys/${uuidWL}/${uuidUser}`;
        return this.api.get(uri);
    }
};
SpeViewNPrePixProxy = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiService])
], SpeViewNPrePixProxy);

let UiPxPrePixModule = class UiPxPrePixModule {
};
UiPxPrePixModule = __decorate([
    NgModule({
        declarations: [],
        imports: [
            UiBsOauthModule
        ],
        providers: [
            SpeNPrePixProxy,
            SpeViewNPrePixProxy
        ]
    })
], UiPxPrePixModule);

class PrePixKeys {
}

export { PrePixKeys, SpeNPrePixProxy, SpeViewNPrePixProxy, UiPxPrePixModule };
//# sourceMappingURL=wlp-ui-px-pre-pix.js.map
